/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_preset_meta_description = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A free online ${i?.label} timer. Start a full-screen ${i?.label} countdown with an alarm in one click — no signup. Set it and forget it.`)
};

const es_timer_preset_meta_description = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Temporizador de ${i?.label} online gratis. Inicia una cuenta regresiva de ${i?.label} a pantalla completa con alarma en un clic — sin registro. Configúralo y olvídate.`)
};

const de_timer_preset_meta_description = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ein kostenloser Online-${i?.label}-Timer. Starte einen ${i?.label}-Countdown im Vollbild mit Alarm per Klick — keine Anmeldung. Einstellen und vergessen.`)
};

const nl_timer_preset_meta_description = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Een gratis online ${i?.label}-timer. Start met één klik een schermvullende ${i?.label}-aftelling met alarm — geen aanmelding nodig. Instellen en vergeten.`)
};

const fr_timer_preset_meta_description = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un minuteur ${i?.label} en ligne gratuit. Lancez un compte à rebours ${i?.label} plein écran avec alarme en un clic — sans inscription. Réglez-le et oubliez-le.`)
};

const it_timer_preset_meta_description = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un timer ${i?.label} online gratuito. Avvia un countdown ${i?.label} a schermo intero con allarme in un clic — nessuna registrazione. Imposta e dimentica.`)
};

const pt_br2_timer_preset_meta_description = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Temporizador de ${i?.label} grátis. Contagem regressiva de ${i?.label} em tela cheia com alarme, em um clique — sem cadastro. Configure e esqueça.`)
};

const pt_timer_preset_meta_description = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Um temporizador de ${i?.label} online gratuito. Inicie uma contagem decrescente de ${i?.label} em ecrã inteiro com alarme, com um clique — sem registo. Configure e esqueça.`)
};

const ja_timer_preset_meta_description = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`無料のオンライン${i?.label}タイマー。ワンクリックでアラーム付きの${i?.label}カウントダウンを全画面でスタート。登録不要。設定したらあとはお任せ。`)
};

const zh_timer_preset_meta_description = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`免费在线${i?.label}计时器。一键启动全屏${i?.label}倒计时，带闹铃提醒 — 无需注册。设置后即可放心等待。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ label: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_preset_meta_description = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_preset_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_preset_meta_description", locale)
	if (locale === "en") return en_timer_preset_meta_description(inputs)
	if (locale === "es") return es_timer_preset_meta_description(inputs)
	if (locale === "de") return de_timer_preset_meta_description(inputs)
	if (locale === "nl") return nl_timer_preset_meta_description(inputs)
	if (locale === "fr") return fr_timer_preset_meta_description(inputs)
	if (locale === "it") return it_timer_preset_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_timer_preset_meta_description(inputs)
	if (locale === "pt") return pt_timer_preset_meta_description(inputs)
	if (locale === "ja") return ja_timer_preset_meta_description(inputs)
	return zh_timer_preset_meta_description(inputs)
};